import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Home from "./pages/Home";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Aboutt from "./pages/OldAbout";
import Dashboard from "./pages/Dashboard";
import Contact from "./pages/Contact";
import LoginPage from "./pages/FrontLogin";
import Register from "./pages/Register";
import Navbar from "./components/Navbar";
import SearchBar from "./components/SearchBar";
import Footer from "./components/footer";
import Logout from "./components/logout";
import Payment from "./components/PaymentPage";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import CourseDetail from "./pages/CourseDetail";
import Courses from "./pages/AllCourse";
import CatCourses from "./pages/CategoryCourse";
import Cart from "./pages/Cart";
import Terms from "./pages/terms";
import Privacy from "./pages/privacyPolicy";
import Success from "./pages/Success";
import Failed from "./pages/Failed";
import ResetPassword from "./pages/ResetPassword";
import BookingQuestions from "./pages/BookingQuestions";
import BookingPaymentWrapper from "./pages/BookingPayment";
import axios from "axios";
import { sattingApi } from "./apis/homeApi";

const App = () => {
  const [sattingData, SetsattingData] = useState([]);

  useEffect(() => {
    try {
      axios.get(sattingApi).then((response) => {
        if (response.status === 200) {
          SetsattingData(response?.data?.data);
        }
      });
    } catch (error) {
      console.error("Error fetching partners:", error);
    }
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <SearchBar />
        <Navbar />

        <Routes>
          <Route path="/" element={<Home homeData={sattingData} />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog-detail/:id" element={<BlogDetail />} />
          <Route path="/course-detail/:id" element={<CourseDetail />} />
		 

<Route path="/booking/questions/:id" element={<BookingQuestions />} />

          <Route path="/booking/:id/payment" element={<BookingPaymentWrapper />} />
          <Route path="/category/course/:id" element={<CatCourses />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/about1" element={<Aboutt />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/success" element={<Success />} />
          <Route path="/failed" element={<Failed />} />
          <Route path="/privacy-policies" element={<Privacy />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/logout" element={<Logout />} />
        </Routes>

        <Footer footerData={sattingData} />
      </Router>
    </HelmetProvider>
  );
};

export default App;
